import React, { Component } from 'react';
import { Modal, Form, Row, Col, Input, InputNumber, Switch, DatePicker, TreeSelect } from 'antd';
import moment from 'moment';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import DictSelect from '../../ui/DictSelect';
import orgUtil from '../../ui/orgUtil';
import EditorContent from '../../ui/EditorContent'

const fields = [{
    "text": "标题",
    "field": "title",
    rules: [
        { required: true, message: '标题不能为空!' },
        { max: 32, message: '标题不能超过32个字符！' },
    ]
}, {
    "text": "消息类型",
    "field": "type",
    "select": true,
    "category": "NOTICE_TYPE",
    rules: [
        { required: true, message: '消息类型不能为空!' },
    ]
}, {
    "text": "是否置顶",
    "field": "roof",
    "radio": true,
}, {
    "text": "显示顺序",
    "field": "sequence",
    "number": true,
    rules: [
        { required: true, message: '显示顺序不能为空!' },
    ]
}, {
    "text": "开始时间",
    "field": "startValidity",
    rules: [
        { required: true, message: '开始时间不能为空!' },
    ],
    date: true
}, {
    "text": "结束时间",
    "field": "endValidity",
    rules: [
        { required: true, message: '结束时间不能为空!' },
    ],
    date: true
}, {
    "text": "通知组织",
    "field": "orgCode",
    "org": true,
}, {
    "text": null,
}, {
    "text": "展示内容",
    "field": "content",
    textarea: true,
    full: true
}];


class NoticeEditForm extends Component {

    state = {
        orgList: [], //市场信息
    }

    componentDidMount() {
        orgUtil.findOrg(
            {},
            (res) => {
                this.setState({ orgList: res });
            }
        );
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id;
            if (id !== undefined && id != null) {
                values["id"] = id;
            }
            values["roof"] = values["roof"] === true ? 1 : 0;
            values["startValidity"] = values["startValidity"].format("YYYY-MM-DD HH:mm:ss");
            values["endValidity"] = values["endValidity"].format("YYYY-MM-DD HH:mm:ss");
            values["content"] = this.getValue();
            http.post({
                url: '/notice/saveNotice',
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    getValueRef = (getValue) => {
        this.getValue = getValue;
    }

    createDom = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i += 2) {
            let item = (<Row key={i}>  
                {/* 第一条判断full是为true则单独一行 */}
                <Col span={data[i].full ? 24 : 12}>
                    {this.createDomItem(data[i])}
                </Col>
                {
                    // 第二条判断full为true则第二条为空
                    data[i].full ? '' : (
                        <Col span={11} offset={1}>
                            {(i + 1) < data.length && data[i + 1].text != null ? this.createDomItem(data[i + 1]) : ''}  
                        </Col>
                    )
                }
            </Row>);
            dom.push(item);
        }
        return dom;
    };
    createDomItem = (item) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let content = editData.content;
        let domItem = "";
        domItem = (
            <Form.Item label={item.text + "："}  labelCol={{span: item.full?3:6}} wrapperCol={{span: item.full?21:18}}>
                {getFieldDecorator(item.field, {
                    rules: item.rules,
                    initialValue:
                        item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                            : item.radio ? editData[item.field] === 1 : editData[item.field],
                    valuePropName: item.radio ? 'checked' : 'value',

                })(
                    item.select ? <DictSelect category={item.category} />
                        : item.radio ? <Switch checkedChildren="是  " unCheckedChildren="否" />
                            : item.number ? <InputNumber precision={0} min={1} style={{ width: '100%' }} />
                                : item.date ? <DatePicker style={{ width: '100%' }} showTime={true} />
                                    : item.org ? <TreeSelect treeData={this.state.orgList} treeDefaultExpandAll={true} allowClear={true} />
                                        : item.textarea ? <EditorContent editDataContent={content} getValueRef={this.getValueRef} editorFlag={this.props.visible} />
                                            : <Input />
                )}
            </Form.Item>
        );
        return domItem;

    }

    render() {
        const { visible, onCancel } = this.props;
        return (

            <Modal
                width={1000}
                visible={visible}
                title="公告信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.setState({ image: null, imageUrl: null }); this.props.form.resetFields() }}
            >
                <Form layout="vertical" className="ant-notice-modal" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const NoticeEdit = Form.create()(NoticeEditForm);

export default NoticeEdit;